module.exports = __webpack_public_path__ + "img/hipercard.8af1c6d7.svg";